export interface FilterPanelMeasurement {
  scrollHeight: number;
  toolbarHeight: number;
  searchWidth: number;
  searchHeight: number;
  paddingHeight: number;
  borderHeight: number;
}

export interface FilterPanelHeights {
  expandedHeight: number;
  collapsedHeight: number;
}

export interface FilterPanelStabilityOptions {
  measure(): boolean;
  hasOpenOverlay(): boolean;
  requestFrame(callback: () => void): void;
}

export function validatedFilterPanelHeights(
  measurement: FilterPanelMeasurement,
): FilterPanelHeights | null {
  const values = Object.values(measurement);
  if (values.some((value) => !Number.isFinite(value) || value < 0)) {
    return null;
  }
  if (
    measurement.scrollHeight === 0 ||
    measurement.toolbarHeight === 0 ||
    measurement.searchWidth === 0 ||
    measurement.searchHeight === 0
  ) {
    return null;
  }

  const expandedHeight = Math.ceil(
    measurement.scrollHeight + measurement.borderHeight,
  );
  const collapsedHeight = Math.ceil(
    measurement.toolbarHeight +
      measurement.paddingHeight +
      measurement.borderHeight,
  );
  if (expandedHeight < collapsedHeight) {
    return null;
  }
  return { expandedHeight, collapsedHeight };
}

export function createFilterPanelStabilityCheck({
  measure,
  hasOpenOverlay,
  requestFrame,
}: FilterPanelStabilityOptions): () => void {
  let scheduled = false;
  return function scheduleFilterStabilityCheck(): void {
    if (scheduled) {
      return;
    }
    scheduled = true;
    requestFrame(() => {
      if (hasOpenOverlay()) {
        scheduled = false;
        return;
      }
      if (measure()) {
        scheduled = false;
        return;
      }
      requestFrame(() => {
        scheduled = false;
        measure();
      });
    });
  };
}
